import {Chip, type ChipProps} from '@mui/material';
import {getTagSx, type TagColor} from './tag.styles';

const TAG_CLASS_NAME = 'MithraTag-root';

export type TagProps = Omit<ChipProps, 'color'> & {
    color?: TagColor;
};

/** Tag is a Chip preset for tag and filter use cases. */
export const Tag = ({
                        color = 'info',
                        size = 'small',
                        variant = 'filled',
                        className,
                        sx,
                        ...props
                    }: TagProps) => (
    <Chip
        className={className ? `${TAG_CLASS_NAME} ${className}` : TAG_CLASS_NAME}
        color="default"
        size={size}
        variant={variant}
        sx={[getTagSx(color, variant), {minHeight: 24, '&&': {borderRadius: 0.5}}, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
        {...props}
    />
);
